package one.healthium.insights.ui.components

import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import one.healthium.base.preferences.AppPreferences
import org.koin.compose.koinInject

@Composable
fun persistableLazyListState(enabled: Boolean, key: String?): LazyListState {
    val appPreferences = koinInject<AppPreferences>()

    var initialFirstVisibleItemIndex = 0
    var initialFirstVisibleItemScrollOffset = 0

    remember(enabled, key) {
        if (enabled && key == appPreferences.contentScrollSavedId) {
            initialFirstVisibleItemIndex = appPreferences.contentSavedScrollFirstItemIndex ?: 0
            initialFirstVisibleItemScrollOffset = appPreferences.contentSavedScrollFirstItemOffset ?: 0
        }
    }

    val state = rememberLazyListState(
        initialFirstVisibleItemIndex = initialFirstVisibleItemIndex,
        initialFirstVisibleItemScrollOffset = initialFirstVisibleItemScrollOffset,
    )

    DisposableEffect(Unit) {
        onDispose {
            if (enabled) {
                appPreferences.contentSavedScrollFirstItemIndex = state.firstVisibleItemIndex
                appPreferences.contentSavedScrollFirstItemOffset = state.firstVisibleItemScrollOffset
                appPreferences.contentScrollSavedId = key
            }
        }
    }

    return state
}